import { useChannelName } from '../hooks/useChannelName';
import { jsx as _jsx } from "react/jsx-runtime";
export const withChannelName = Component => {
  const ComponentWithChannelName = props => {
    const {
      genericChannelId
    } = props.message;
    const channelName = useChannelName(genericChannelId);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      channelName: channelName
    }));
  };
  ComponentWithChannelName.displayName = `withChannelName(${Component.displayName})`;
  return ComponentWithChannelName;
};